// 根据环境换区根域名
export const getRootDomain = () => {
    return import.meta.env.VITE_RootDomain
  }
  // 根域名地址
  export const rootDomainPage = 'https://' + getRootDomain()
  // 根域名退出地址
  export const rootDomainSignOutPage = rootDomainPage + `/logout/index.html?return_to=${encodeURIComponent('/#/login/wechat')}`
  // 根域名登入地址
  export const rootDomainLoginPage = rootDomainPage + '/#/login/wechat?return_to='
  // 根域名登入地址
  export const rootDomainRefreshPage = rootDomainPage + '/#/login/webrefresh?return_to='
  